const updateVariantInput = () => {
  const productForms = document.querySelectorAll(
    `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
  );
  productForms.forEach((productForm) => {
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
};

const updateVariantStatuses = () => {
  const selectedOptionOneVariants = this.variantData.filter(
    (variant) => this.querySelector(":checked").value === variant.option1
  );
  const inputWrappers = [...this.querySelectorAll(".product-form__input")];
  inputWrappers.forEach((option, index) => {
    if (index === 0) return;
    const optionInputs = [
      ...option.querySelectorAll('input[type="radio"], option'),
    ];
    const previousOptionSelected =
      inputWrappers[index - 1].querySelector(":checked").value;
    const availableOptionInputsValue = selectedOptionOneVariants
      .filter(
        (variant) =>
          variant.available &&
          variant[`option${index}`] === previousOptionSelected
      )
      .map((variantOption) => variantOption[`option${index + 1}`]);
    this.setInputAvailability(optionInputs, availableOptionInputsValue);
  });
};

const setInputAvailability = (listOfOptions, listOfAvailableOptions) => {
  listOfOptions.forEach((input) => {
    if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
      input.innerText = input.getAttribute("value");
    } else {
      input.innerText = Moonbase.variantStrings.unavailable_with_option.replace(
        "[value]",
        input.getAttribute("value")
      );
    }
  });
};

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formID = this.form.querySelector("[name=id]");
        if (this.formID) this.formID.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler);
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(event) {
        event.preventDefault();
        this.submitButton = this.querySelector('[type="submit"]');
        const spinner = this.submitButton.querySelector(
          ".loading-overlay__spinner"
        );
        if (spinner) spinner.classList.remove("hidden");
        this.submitButton.classList.add("loading");

        // Chain product logic
        const chainVariant = document.querySelector("#chain-variant-id");
        if (chainVariant && chainVariant.value) {
          window.liquidAjaxCart.add({
            id: chainVariant.value,
            quantity: 1,
            properties: {
              "Chain product": chainVariant.getAttribute("data-title"),
            },
          });

          // FIX: Wenn sowohl der Anhaenger als auch eine Kette in den
          // Warenkorb gelegt werden, feuern hier zwei getrennte
          // /cart/add.js-Requests (dieser manuelle Aufruf fuer die Kette,
          // sowie der native Submit ueber <ajax-cart-product-form> fuer den
          // Anhaenger). Beide Artikel werden dabei zuverlaessig korrekt in
          // den Warenkorb gelegt (per /cart.js geprueft) -- ABER die
          // "Produkt zum Warenkorb hinzugefuegt"-Vorschau (#js-minicart)
          // wird theme-seitig nur von EINEM der beiden Requests aktualisiert
          // (welcher, ist nicht zuverlaessig vorhersagbar/reihenfolgeabhaengig),
          // wodurch je nach Fall nur der Anhaenger ODER nur die Kette in der
          // Vorschau auftaucht, nie beide.
          //
          // Statt zu versuchen, den zweiten Request zu unterdruecken oder zu
          // erzwingen, dass beide Artikel im selben Request landen (beides in
          // Tests nicht zuverlaessig moeglich, ohne die Drittanbieter-Logik
          // von <ajax-cart-product-form>/liquid-ajax-cart zu beeinflussen),
          // ergaenzen wir die Vorschau nachtraeglich: Sobald die komplette
          // Warenkorb-Request-Queue fertig ist (liquid-ajax-cart:queue-end),
          // pruefen wir, ob sowohl der Anhaenger- als auch der Kette-Titel im
          // aktuell angezeigten Vorschau-Inhalt vorkommen, und ergaenzen bei
          // Bedarf einen kurzen Hinweistext fuer das fehlende Produkt.
          const chainTitle = chainVariant.getAttribute("data-title") || "";
          const pendantTitleEl = document.querySelector("h1");
          const pendantTitle = pendantTitleEl
            ? pendantTitleEl.textContent.trim()
            : "";

          const addMissingCartNotificationNotes = () => {
            const notifSection = document.getElementById("js-minicart");
            if (!notifSection) return;
            const itemsWrapper = notifSection.querySelector(".minicart__items");
            if (!itemsWrapper) return;

            // Hinweise aus einem vorherigen Durchlauf entfernen, damit sie
            // sich bei mehrfachem Hinzufuegen nicht ansammeln.
            notifSection
              .querySelectorAll(".js-chain-added-note")
              .forEach((el) => el.remove());

            const shownText = itemsWrapper.textContent || "";
            const missingTitles = [];

            if (pendantTitle && !shownText.includes(pendantTitle)) {
              missingTitles.push(pendantTitle);
            }

            // Nur den reinen Produktnamen der Kette vergleichen (vor " - "),
            // da data-title zusaetzlich die Variante enthaelt.
            const chainProductTitle = chainTitle.split(" - ")[0].trim();
            if (chainProductTitle && !shownText.includes(chainProductTitle)) {
              missingTitles.push(chainTitle);
            }

            missingTitles.forEach((title) => {
              const note = document.createElement("div");
              note.className = "js-chain-added-note";
              note.style.cssText =
                "padding: 12px 20px; font-size: 13px; color: #555; border-top: 1px solid rgb(224, 220, 224);";
              note.textContent = `+ ${title} wurde ebenfalls hinzugefügt.`;
              itemsWrapper.after(note);
            });
          };

          document.addEventListener(
            "liquid-ajax-cart:queue-end",
            addMissingCartNotificationNotes,
            { once: true }
          );
        }

        setTimeout(() => {
          spinner?.classList.add("hidden");
          this.submitButton.classList.remove("loading");
        }, 2000);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.addEventListener("change", this.onVariantChange);

    // Build a map of all variant option combinations to images
    this.variantImageMap = {};
    this.getVariantData().forEach(variant => {
      if (variant.id && variant.featured_image) {
        this.variantImageMap[variant.id] = variant.featured_image.src;
      }
    });

    this.productOptions = JSON.parse(this.dataset.productOptions || "[]");
  }

  // FIX: On initial page load (including direct links with ?variant=...),
  // updateVariantInfo() was never called -- previously it only ran on a
  // "change" event from the variant picker. Because of this, the Details
  // section always showed the values from the product-level metafield
  // (custom.product_details) on first load, regardless of which variant
  // was actually selected/linked -- the correct, variant-specific values
  // (variant.metafields.variant.product_details) only appeared after the
  // customer clicked something in the picker.
  // Mirroring the fix already present in the B2B theme, this runs the same
  // sync pipeline as a variant change once on DOMContentLoaded (excluding
  // updateMedia()/updateURL(), so the normal image gallery is still shown
  // on first load instead of the variant-specific images).
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      this.updateOptions();
      this.updateMasterId();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateVariantInfo();
      this.updateVariantStatuses();
      this.updateFormInputID();
    });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateFormInputID();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateVariantInfo();
    }
  }

  updateVariantInfo() {
    // FIX: Defensive check, since updateVariantInfo() is now also called
    // on initial load (init()), not just after a "change" event. Bail out
    // early instead of throwing if the script tag doesn't exist (yet) or
    // this.currentVariant couldn't be determined on first load.
    const metafieldsScript = document.querySelector("script[data-variant-metafields]");
    if (!metafieldsScript || !this.currentVariant) return;

    const variantMetafieldsJSON = JSON.parse(metafieldsScript.textContent);
    const matchingVariant = variantMetafieldsJSON[this.currentVariant.id];
    if (!matchingVariant) return;

    // Update Product Details with Variant Metafield Information
    const productDescriptionElement = document.querySelector(
      ".js-product-details"
    );

    if (productDescriptionElement) {
      if (matchingVariant[0].description) {
        productDescriptionElement.innerHTML = matchingVariant[0].description;
      }
    }

    // Update Shipping Information with Variant Metafield Information
    const productShippingElement = document.querySelector(
      ".js-shipping-details"
    );

    if (productShippingElement) {
      if (matchingVariant[0].shipping_information) {
        productShippingElement.innerHTML =
          matchingVariant[0].shipping_information;
      }
    }

    const selectors = {
      materialsText: {
        selector: document.querySelector(".js-product-materials-text"),
        newText: (matchingVariant[0]?.product_details?.material_text || "").replace(/\s*\[.*?\]/, ''),
        isImage: false,
      },
      productCodeText: {
        selector: document.querySelector(".js-product-code-text"),
        newText: matchingVariant[0]?.product_details?.product_code_text || "",
        isImage: false,
      },
      pendantLengthText: {
        selector: document.querySelector(".js-product-pendant-length-text"),
        newText: matchingVariant[0]?.product_details?.pendant_length_text || "",
        isImage: false,
      },
      acornLengthText: {
        selector: document.querySelector(".js-product-acorn-length-text"),
        newText: matchingVariant[0]?.product_details?.acorn_length_text || "",
        isImage: false,
      },
      drawerMaterialsImage: {
        selector: document.querySelector(".js-product-materials-image"),
        newText: matchingVariant[0]?.product_details?.material_image || "",
        isImage: true,
      },
    };

    Object.values(selectors).forEach((selector) => {
      const element = selector.selector;
      if (element) {
        if (selector.isImage === true) {
          element.innerHTML = `<img src="${selector.newText}" alt="Image" class="w-[25px] h-[25px] object-contain" />`;
        } else {
          element.innerHTML = selector.newText;
        }

        // NEU: das umschliessende <li> ein-/ausblenden, je nachdem ob die
        // aktuell ausgewaehlte Variante einen Wert fuer dieses Feld hat.
        // Noetig, weil das <li> jetzt (siehe main-product.liquid) immer im
        // DOM existiert -- vorher fehlte es komplett, wenn die zuerst
        // geladene Variante hier leer war, und querySelector() fand dann
        // dauerhaft nichts mehr, auch nach einem Wechsel zu einer Variante
        // mit gefuelltem Wert.
        // .trim() zusaetzlich, damit ein Feld, das nur aus einem
        // Leerzeichen besteht (kein "leerer" String im strikten Sinn),
        // trotzdem korrekt als leer behandelt und das <li> versteckt wird.
        const wrapper = element.closest("li");
        if (wrapper) wrapper.classList.toggle("hidden", !String(selector.newText || "").trim());
      }
    });
    if (
      matchingVariant[0].variant_images &&
      matchingVariant[0].variant_images.length > 0
    ) {
      this.updateSecondarySwiper(matchingVariant[0].variant_images);
    }
  }

  updateSecondarySwiper(variantImages) {
    const swiperContainer = document.querySelector(
      ".product-secondary__gallery"
    );
    if (!swiperContainer) return;

    const swiperWrapper = swiperContainer.querySelector(".swiper-wrapper");
    if (!swiperWrapper) return;

    // Clear existing slides
    swiperWrapper.innerHTML = "";

    // Add new slides for each variant image
    variantImages.forEach((image) => {
      const slide = document.createElement("div");
      slide.classList.add("swiper-slide");
      slide.innerHTML = `<img src="${image}" />`;
      swiperWrapper.appendChild(slide);
    });

    // Update Swiper instance
    const swiperOptions = JSON.parse(
      swiperContainer.getAttribute("data-swiper") || "{}"
    );

    new window.Moonbase.Swiper(swiperContainer, swiperOptions);
  }

  updateFormInputID() {
    const productInfo = this.closest("product-info");
    if (!productInfo) return;
    const input = productInfo.querySelector(".product-variant-id");
    input.value = this.currentVariant.id;
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const threediumEmbed = document.querySelector(".threedium-embed");

    if (threediumEmbed) {
      const imageHtml = `
        <img
          src="${this.currentVariant.featured_image.src}"
          srcset="
            ${this.currentVariant.featured_image.src}&width=400 400w,
            ${this.currentVariant.featured_image.src}&width=500 500w,
            ${this.currentVariant.featured_image.src}&width=600 600w,
            ${this.currentVariant.featured_image.src}&width=700 700w,
            ${this.currentVariant.featured_image.src}&width=800 800w,
            ${this.currentVariant.featured_image.src}&width=1000 1000w,
            ${this.currentVariant.featured_image.src}&width=1400 1400w,
            ${this.currentVariant.featured_image.src}&width=1600 1600w,
            ${this.currentVariant.featured_image.src}&width=1800 1800w
          "
          sizes="(min-width: 1024px) 50vw, 100vw"
          alt="${this.currentVariant.featured_image.alt || this.currentVariant.title}"
          class='w-full h-full object-contain'
        />
      `;
      threediumEmbed.innerHTML = imageHtml;
    } else {
      const gallerySwiper = document.querySelector(
        ".product-main__gallery"
      ).swiper;
      const newSlideHtml = `
        <div class="swiper-slide">
          <img
            src="${this.currentVariant.featured_image.src}"
            srcset="
              ${this.currentVariant.featured_image.src}&width=400 400w,
              ${this.currentVariant.featured_image.src}&width=500 500w,
              ${this.currentVariant.featured_image.src}&width=600 600w,
              ${this.currentVariant.featured_image.src}&width=700 700w,
              ${this.currentVariant.featured_image.src}&width=800 800w,
              ${this.currentVariant.featured_image.src}&width=1000 1000w,
              ${this.currentVariant.featured_image.src}&width=1400 1400w,
              ${this.currentVariant.featured_image.src}&width=1600 1600w,
              ${this.currentVariant.featured_image.src}&width=1800 1800w
            "
            sizes="(min-width: 1024px) 50vw, 100vw"
            alt="${this.currentVariant.featured_image.alt || this.currentVariant.title}"
          />
        </div>`;
      gallerySwiper.removeAllSlides();
      gallerySwiper.appendSlide(newSlideHtml);
      gallerySwiper.update();

      const drawers = document.querySelectorAll("drawer-component");

      drawers.forEach(drawer => {
        const mobileImage = drawer.querySelector(".mobile-selected-variant");
        if(mobileImage) {
          mobileImage.src = this.currentVariant.featured_image.src;
          mobileImage.alt = this.currentVariant.featured_image.alt;

          if (this.currentVariant.featured_image.srcset) {
            mobileImage.srcset = this.currentVariant.featured_image.srcset;
          }
          else {
            mobileImage.srcset = '';
          }
        }
      });
    }

    // Update option selector thumbnails to match the selected variant
    const optionLists = document.querySelectorAll(".shopify-product-form .product-options li");
    const activeOption = document.querySelector("drawer-component.drawer--open .product-options li").getAttribute("data-option-name");

    optionLists.forEach(listItem => {
      const optionName = listItem.dataset.optionName;

      if (optionName === activeOption) {
        return;
      }

      const optionValue = listItem.dataset.optionValue;
      const selections = [...this.options];
      const optionIndex = this.productOptions.findIndex(
        opt => opt.toLowerCase() === optionName.toLowerCase()
      );

      if (optionIndex === -1) return;

      selections[optionIndex] = optionValue;

      const variant = this.getVariantData().find(v =>
        v.options.every((opt, i) => opt === selections[i])
      );

      const imgTag = listItem.querySelector("img");
      if (variant && variant.featured_image && imgTag) {
        imgTag.src = variant.featured_image.src;

        imgTag.alt = variant.featured_image.alt || optionValue;

        if (variant.featured_image.srcset) {
          imgTag.srcset = variant.featured_image.srcset;
        }
        else {
          imgTag.srcset = '';
        }

        listItem.classList.remove("disabled");
      }
      else {
        listItem.classList.add("disabled");
        if (imgTag) {
          imgTag.src = "";
          imgTag.srcset = "";
        }
      }
    });
  }

  selectedOptions() {
    return Array.from(document.querySelectorAll("li.selected")).map(el => ({
      optionName: el.dataset.optionName,
      optionValue: el.dataset.optionValue
    }));
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText =
          Moonbase.variantStrings.unavailable_with_option.replace(
            "[value]",
            input.getAttribute("value")
          );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          Moonbase.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = Moonbase.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = Moonbase.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

// Create a web component for the quantity-input
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.minusButton = this.querySelector(".minus");
    this.plusButton = this.querySelector(".plus");
    this.quantityInput = this.querySelector(".quantity__input");
    this.init();
  }

  init() {
    this.minusButton.addEventListener("click", this.minusQty.bind(this));
    this.plusButton.addEventListener("click", this.addQty.bind(this));
  }

  minusQty() {
    if (parseInt(this.quantityInput.value) > 1) {
      this.quantityInput.value = --this.quantityInput.value;
    }
  }

  addQty() {
    if (parseInt(this.quantityInput.value) < parseInt(this.quantityInput.max)) {
      this.quantityInput.value = ++this.quantityInput.value;
    } else {
      this.plusButton.setAttribute("disabled", "disabled");
    }
  }
}

customElements.define("quantity-input", QuantityInput);

// NEU: Echte Options-Auswahl (z.B. Material + Groesse) fuer die einzelnen
// Kette-Produkte im "chain"-Drawer. Vorher wurde beim Bestaetigen einer
// Kette immer stumpf die erste verfuegbare Variante genommen -- es gab
// keine Moeglichkeit, Material/Laenge auszuwaehlen, obwohl die verlinkten
// Kette-Produkte (z.B. BELCHER Kette) mehrere Varianten haben.
//
// <chain-variant-selects> wird pro verlinktem Kette-Produkt gerendert
// (siehe product-variant-picker.liquid, "chain"-Block) und enthaelt:
// - je Produktoption ein <select> (.js-chain-option-select)
// - die komplette Variantenliste des Produkts als JSON (.js-chain-variant-data)
// - eine vorformatierte Preis-Map pro Variant-ID (.js-chain-variant-prices),
//   damit hier keine eigene Waehrungsformatierung in JS noetig ist
// - einen Bestaetigen-Button (.js-chain-variant-confirm), der erst aktiv
//   wird, sobald die aktuelle Options-Kombination einer verfuegbaren
//   Variante entspricht
//
// Beim Bestaetigen wird die gewaehlte Variante (id + Titel) in das schon
// bestehende #chain-variant-id-Feld geschrieben, das beim Absenden des
// Produktformulars (siehe ProductForm.onSubmitHandler weiter oben) bereits
// ausgelesen und dem Warenkorb hinzugefuegt wird -- an dieser Stelle musste
// also nichts geaendert werden.
class ChainVariantSelects extends HTMLElement {
  constructor() {
    super();

    // WICHTIG: moonbase-main.js enthaelt noch einen aelteren, nie fertig
    // verdrahteten Klick-Handler auf ".style-products li" (aus der Zeit vor
    // dieser Material/Groesse-Auswahl), der bei jedem Klick innerhalb des
    // <li> die Attribute data-variant-id/data-title des <li> selbst liest
    // und #chain-variant-id ueberschreibt. Unser <li> hat diese Attribute
    // nicht mehr (die Variante wird jetzt ueber die Selects ermittelt),
    // wodurch dieser alte Handler #chain-variant-id bei jedem Klick
    // (z.B. auf den Auswaehlen-Button) direkt danach wieder auf leer/"null"
    // zuruecksetzt. Da wir den kompilierten Bundle-Code nicht anfassen
    // koennen, unterbinden wir stattdessen, dass Klicks innerhalb dieser
    // Komponente ueberhaupt bis zum <li> hochblubbern.
    this.addEventListener("click", (event) => {
      event.stopPropagation();
    });

    const variantDataScript = this.querySelector(".js-chain-variant-data");
    const priceDataScript = this.querySelector(".js-chain-variant-prices");

    this.variantData = variantDataScript
      ? JSON.parse(variantDataScript.textContent)
      : [];
    this.priceMap = priceDataScript
      ? JSON.parse(priceDataScript.textContent)
      : {};

    this.optionSelects = Array.from(
      this.querySelectorAll(".js-chain-option-select")
    ).sort(
      (a, b) =>
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
    );

    this.priceElement = this.querySelector(".js-chain-variant-price");
    this.unavailableElement = this.querySelector(
      ".js-chain-variant-unavailable"
    );
    this.confirmButton = this.querySelector(".js-chain-variant-confirm");
    this.imageElement = this.querySelector(".js-chain-variant-image");

    this.optionSelects.forEach((select) => {
      select.addEventListener("change", this.onOptionChange.bind(this));
    });

    if (this.confirmButton) {
      this.confirmButton.addEventListener(
        "click",
        this.onConfirm.bind(this)
      );
    }

    // Direkt beim Laden einmal synchronisieren, falls die vorausgewaehlten
    // <option selected>-Werte nicht der ersten Variante entsprechen.
    this.onOptionChange();
  }

  getSelectedOptionValues() {
    return this.optionSelects.map((select) => select.value);
  }

  findMatchingVariant() {
    const selected = this.getSelectedOptionValues();
    return this.variantData.find((variant) =>
      variant.options.every((value, index) => value === selected[index])
    );
  }

  onOptionChange() {
    this.currentVariant = this.findMatchingVariant();
    const isAvailable = !!(this.currentVariant && this.currentVariant.available);

    if (this.unavailableElement) {
      this.unavailableElement.classList.toggle("hidden", isAvailable);
    }

    if (this.priceElement) {
      this.priceElement.classList.toggle("hidden", !isAvailable);
      if (isAvailable) {
        this.priceElement.textContent =
          this.priceMap[this.currentVariant.id] || "";
      }
    }

    if (this.confirmButton) {
      this.confirmButton.disabled = !isAvailable;
    }

    if (isAvailable && this.imageElement && this.currentVariant.featured_image) {
      const rawSrc = this.currentVariant.featured_image.src;
      const separator = rawSrc.includes("?") ? "&" : "?";
      this.imageElement.src = `${rawSrc}${separator}width=400`;
      this.imageElement.srcset = "";
      if (this.currentVariant.featured_image.alt) {
        this.imageElement.alt = this.currentVariant.featured_image.alt;
      }
    }
  }

  onConfirm() {
    if (!this.currentVariant || !this.currentVariant.available) return;

    const chainVariantInput = document.querySelector("#chain-variant-id");
    if (chainVariantInput) {
      const productTitle = this.dataset.productTitle || "";
      const variantTitle = this.currentVariant.title || "";
      chainVariantInput.value = this.currentVariant.id;
      chainVariantInput.setAttribute(
        "data-title",
        variantTitle ? `${productTitle} - ${variantTitle}` : productTitle
      );
    }

    // "Kette:"-Label am Drawer-Button aktualisieren, damit die getroffene
    // Auswahl auch ausserhalb der Drawer sichtbar ist.
    const label = document.querySelector(
      'drawer-button[data-drawer="chain"] [data-selected-option]'
    );
    if (label) {
      const style = this.dataset.style || "";
      const variantTitle = this.currentVariant.title || "";
      label.textContent = variantTitle ? `${style} (${variantTitle})` : style;
    }

    // "selected"-Markierung in der Primaer-Liste (Waehle Kette Stil) auf
    // den gerade bestaetigten Stil umziehen, damit Lederband nicht mehr
    // faelschlicherweise als ausgewaehlt markiert bleibt.
    document
      .querySelectorAll("#chain .content.primary li")
      .forEach((li) => li.classList.remove("selected"));
    const primaryStyleLi = document.querySelector(
      `#chain .content.primary li.style-selector[data-style="${this.dataset.style}"]`
    );
    if (primaryStyleLi) primaryStyleLi.classList.add("selected");

    // Drawer schliessen -- ueber den vorhandenen Close-Button, da wir die
    // interne API von <drawer-component> nicht kennen/anfassen wollen.
    const drawer = document.getElementById("chain");
    const closeButton = drawer
      ? drawer.querySelector("[drawer-close-button]")
      : null;
    if (closeButton) closeButton.click();
  }
}

if (!customElements.get("chain-variant-selects")) {
  customElements.define("chain-variant-selects", ChainVariantSelects);
}

// NEU: Das Lederband-/Default-Element (".js-chain-select-default") in der
// "Wähle Kette Stil"-Liste hatte bisher gar keinen Klick-Handler -- es war
// rein informativ. Dadurch konnte man, nachdem einmal eine bezahlte Kette
// (Belcher/Eight) bestaetigt wurde, nicht mehr zurueck zum inkludierten
// Lederband wechseln: #chain-variant-id blieb dauerhaft auf der zuletzt
// gewaehlten Kette-Variante stehen.
//
// Dieser Handler setzt beim Klick auf das Lederband-Element das Feld
// wieder zurueck (leer = "keine zusaetzliche Kette, Lederband ist im
// Lieferumfang enthalten"), aktualisiert das "Kette:"-Label und die
// "selected"-Markierung entsprechend und schliesst die Drawer.
document.addEventListener("DOMContentLoaded", () => {
  const defaultOption = document.querySelector(".js-chain-select-default");
  if (!defaultOption) return;

  defaultOption.addEventListener("click", () => {
    const chainVariantInput = document.querySelector("#chain-variant-id");
    if (chainVariantInput) {
      chainVariantInput.value = "";
      chainVariantInput.setAttribute("data-title", "");
    }

    const label = document.querySelector(
      'drawer-button[data-drawer="chain"] [data-selected-option]'
    );
    if (label) {
      label.textContent = defaultOption.dataset.chainDefaultTitle || "";
    }

    document
      .querySelectorAll("#chain .content.primary li")
      .forEach((li) => li.classList.remove("selected"));
    defaultOption.classList.add("selected");

    const drawer = document.getElementById("chain");
    const closeButton = drawer
      ? drawer.querySelector("[drawer-close-button]")
      : null;
    if (closeButton) closeButton.click();
  });
});
